<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  import { getContext } from "svelte";
  export let label = "Toggle";
  export let name;
  export let value = false;
  export let styledCheckbox = false;
  const { onFormChange } = getContext("form");
  const onChange = (e) => {
    dispatch("onChange", e);
    // console.log({checked,value});
    onFormChange({ checkbox: true }); // not sending name to avoid rewriting data form object
  };
</script>

{#if styledCheckbox == true}
  <label class="container">
    <input
      type="checkbox"
      bind:checked={value}
      name={name}
      on:change={onChange} />
      <span class="checkmark border-4 border-solid rounded {value ? 'border-orange-400' : 'border-gray-400'}" />
    {label}
  </label>
{:else}
  <div class="flex items-center">
    <input
      type="checkbox"
      id="s-checkbox"
      class="focus:ring-yellow-500 h-4 w-4 text-yellow-600 border-gray-400"
      bind:checked={value}
      name={name}
      on:change={onChange} />
    <label
      for="s-checkbox"
      class="ml-1 whitespace-nowrap text-sm font-medium text-gray-700">
      {label}
    </label>
  </div>
{/if}
<!-- Style for the styled-checbox -->
<style>
  /* The container */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 32px;
    width: 32px;
    background-color: #fff;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 7px;
    top: 3px;
    width: 8px;
    height: 15px;
    border: solid orange;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
